function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "caret");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Standup-Team",
  transform: "translate(-96.000000, -592.000000)",
  fill: "#444444"
}, /*#__PURE__*/React.createElement("g", {
  id: "caret",
  transform: "translate(96.000000, 592.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1613483,2.2002749 C5.77105676,1.92419717 5.35706299,1.64733512 4.91936789,1.36968876 C4.4816719,1.10145415 3.95153947,0.800278432 3.32896882,0.466161624 C2.70639817,0.132044817 2.09172796,-0.155013278 1.48495909,-0.395012679 C1.40417242,-0.426724475 1.31821598,-0.443471601 1.23134842,-0.444424312 C1.11457865,-0.445348767 0.999795542,-0.414420204 0.899521767,-0.355012773 C0.721102215,-0.252597506 0.606950218,-0.0675655672 0.596136885,0.136750694 C0.596136885,0.175966281 0.58112533,0.344593304 0.551103108,0.642631772 C0.521080887,0.940670231 0.497378665,1.37047307 0.479997332,1.93204029 C0.456295111,2.49517612 0.444444444,3.03635123 0.444444444,3.55556557 C0.444444444,4.07477995 0.456295111,4.618308 0.479997332,5.18614973 C0.503699554,5.75242279 0.527400887,6.18065708 0.551103108,6.47085241 C0.57480533,6.76104774 0.589815996,6.93281196 0.596136885,6.98614524 C0.60926044,7.18428305 0.723777771,7.36191313 0.899521767,7.45673227 C0.998822209,7.51944529 1.11367109,7.55364909 1.23134842,7.55555556 C1.31821598,7.55460281 1.40417242,7.53785568 1.48495909,7.50614391 C3.59418748,6.63467576 5.56402832,5.46232779 7.33222383,4.02615269 C7.47382827,3.91040227 7.55561227,3.73766121 7.55502205,3.55556557 C7.56306382,3.37190893 7.47979449,3.19603009 7.33222383,3.08497856 C7.27849939,3.03164536 7.1678905,2.93988089 7.00039717,2.80968513 C6.8313234,2.67948939 6.55164074,2.47635265 6.1613483,2.2002749 L6.1613483,2.2002749 Z",
  id: "Shape",
  transform: "translate(4.000000, 3.555556) rotate(-90.000000) translate(-4.000000, -3.555556) "
}))));

var SvgCaret = function SvgCaret(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaret, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret.f34472c7.svg";
export { ForwardRef as ReactComponent };